import tool from '@/utils/tool'

export const MENU_CACHE_VERSION = '20260807_settled_orders'

const hasBrokenTitle = (nodes = []) => {
	for (const node of nodes) {
		const title = typeof node?.title === 'string' ? node.title : ''
		const metaTitle = typeof node?.meta?.title === 'string' ? node.meta.title : ''
		if (title.includes('?') || metaTitle.includes('?') || title.includes('�') || metaTitle.includes('�')) {
			return true
		}
		if (Array.isArray(node?.children) && hasBrokenTitle(node.children)) {
			return true
		}
	}
	return false
}

export const isMenuCacheValid = (menu) => {
	return (
		Array.isArray(menu) &&
		menu.length > 0 &&
		tool.data.get('MENU_CACHE_VERSION') === MENU_CACHE_VERSION &&
		!hasBrokenTitle(menu)
	)
}

export const saveMenuCache = (menu, options = {}) => {
	const { preserveModuleId = true } = options
	tool.data.set('MENU', menu)
	tool.data.set('MENU_CACHE_VERSION', MENU_CACHE_VERSION)
	if (Array.isArray(menu) && menu.length > 0) {
		const currentModuleId = tool.data.get('DIGIT_MENU_MODULE_ID')
		const nextModuleId =
			preserveModuleId && menu.some((item) => item.id === currentModuleId) ? currentModuleId : menu[0].id
		tool.data.set('DIGIT_MENU_MODULE_ID', nextModuleId)
	}
}

export const clearMenuCache = () => {
	tool.data.remove('MENU')
	tool.data.remove('MENU_CACHE_VERSION')
	tool.data.remove('DIGIT_MENU_MODULE_ID')
}
